var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHouse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "6 7 18 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.013 11.856V8.31a.5.5 0 0 0-.494-.507h-1.002a.507.507 0 0 0-.504.507v1.52l-2.649-2.681a.493.493 0 0 0-.706 0l-8.545 8.4c-.196.2-.13.36.146.36H8.01v6.584c0 .28.215.507.492.507h4.006a.506.506 0 0 0 .503-.507v-4.052c0-.28.222-.507.498-.507h3.004c.277 0 .499.227.499.507v4.052c0 .28.227.507.503.507h4.005a.496.496 0 0 0 .492-.507v-6.585h1.73c.277 0 .339-.16.144-.358z"
})));
export default SvgHouse;